import { useEffect, useImperativeHandle, useRef, useState } from "react";
import cn from "classnames";
import styled from "styled-components";
import IconButton from "./IconButton";
import SVG from "src/utils/SVG";

declare global {
  interface Window {
    kakao: any;
  }
}

interface IMapProps {
  address: string;
  callMap?: boolean;
}

const KakaoMap = (props: IMapProps) => {
  const { kakao } = window;
  const [mapState, setMapState] = useState<any>(null);
  const [mapError, setMapError] = useState(false);
  const [addressCenter, setAddressCenter] = useState({
    ma: "",
    la: "",
  });

  useEffect(() => {
    if (props.callMap) {
      const container = document.getElementById("map");
      const options = {
        center: new kakao.maps.LatLng(33.450701, 126.570667),
        level: 3,
      };
      const map = new kakao.maps.Map(container, options);

      // 주소-좌표 변환 객체를 생성
      const geocoder = new window.kakao.maps.services.Geocoder();
      // 주소로 좌표를 검색
      geocoder.addressSearch(props.address, function (result: any, status: any) {
        // 정상적으로 검색이 완료됐으면
        if (status === window.kakao.maps.services.Status.OK) {
          const coords = new window.kakao.maps.LatLng(result[0].y, result[0].x);

          // 결과값으로 받은 위치를 마커로 표시
          const marker = new window.kakao.maps.Marker({
            map: map,
            position: coords,
          });

          setAddressCenter({
            ma: result[0].y,
            la: result[0].x,
          });

          // 지도의 중심을 결과값으로 받은 위치로 이동
          map.setCenter(coords);
          setMapError(false);
        } else {
          setMapError(true);
        }
      });

      kakao.maps.event.addListener(map, "bounds_changed", function () {
        // 지도 영역정보를 얻어옵니다
        const bounds = map.getBounds();

        // 영역정보의 남서쪽 정보를 얻어옵니다
        const swLatlng = bounds.getSouthWest();

        // 영역정보의 북동쪽 정보를 얻어옵니다
        const neLatlng = bounds.getNorthEast();
      });

      map.relayout();
      setMapState(map);
    }
  }, [props]);

  const mapBoxRef = useRef<HTMLDivElement>(null);
  const [reSizeMap, setReSizeMap] = useState(false);

  const toggleMap = () => {
    setReSizeMap(!reSizeMap);
  };

  useEffect(() => {
    if (!reSizeMap) {
      if (mapBoxRef.current) mapBoxRef.current.style.height = "260px";
    } else {
      if (mapBoxRef.current) mapBoxRef.current.style.height = "calc(100vh - 55px)";
    }
    setTimeout(() => {
      mapReset();
    }, 300);
  }, [reSizeMap]);

  const mapReset = () => {
    if (mapState) {
      const moveToCenter = new window.kakao.maps.LatLng(addressCenter.ma, addressCenter.la);
      mapState.relayout();
      mapState.panTo(moveToCenter);
    }
  };

  return (
    <MapBox ref={mapBoxRef} className={cn({ hide: mapError })}>
      <MapContainer id="map" />
      <IconButton btnName="지도보기" onClick={toggleMap}>
        {reSizeMap ? <SVG name="reduce" width={58} height={58} viewBox="0 0 58 58" /> : <SVG name="expand" width={58} height={58} viewBox="0 0 58 58" />}
      </IconButton>
    </MapBox>
  );
};

const MapBox = styled.div`
  position: relative;
  overflow: hidden;
  height: calc(260px + ${({ theme }) => theme.mobile.notchHeight}px);
  transition: height ease-in-out 300ms;
  > div {
    height: 100%;
  }
  > button {
    z-index: 900;
    position: absolute;
    bottom: 0;
    right: 0;
  }
  &.hide {
    display: none;
    & + div {
      margin-top: calc(60px + ${({ theme }) => theme.mobile.notchHeight}px);
    }
  }
`;

const MapContainer = styled.div`
  width: 100%;
  height: 100%;
  /* aspect-ratio: 1; */
`;

export default KakaoMap;
